module.exports = __webpack_public_path__ + "static/media/mksu_logo-2.9702d789.png";